import { jsx as _jsx } from "react/jsx-runtime";
import RGL, { WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import 'app/pages/Project/ProductionManagement/Dashboards/DashboardLayout/styles.scss';
const ResponsiveReactGridLayout = WidthProvider(RGL);
const DashboardLayout = ({ layout, nested, onLayoutChange, children }) => {
    return (_jsx(ResponsiveReactGridLayout, { onDragStart: (a, b, c, d, e) => e.stopPropagation(), useCSSTransforms: false, layout: layout, onDragStop: onLayoutChange, onResizeStop: onLayoutChange, className: "layout", rowHeight: 10, cols: 12, compactType: "vertical", draggableCancel: ".draggableCancel", margin: [20, 20], containerPadding: nested ? [5, 60] : [0, 80], children: children }));
};
export default DashboardLayout;
